var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.info && _vm.info.volunteer_id),expression:"info && info.volunteer_id"}]},[(_vm.showLabel)?_c('div',{staticClass:"detail-info-label"},[_vm._v("可领取的志工列表")]):_vm._e(),_c('a-table',{staticClass:"volunteer-table",attrs:{"columns":_vm.columns,"row-key":"id","data-source":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }